<template>
  <component
    :is="comps[section.component]"
    v-for="(section, idx) in blok.sections"
    :key="section._uid"
    :blok="section"
    :firstSection="idx === 0"
  />
</template>

<script setup lang="ts">
import { TemplatePageStoryblok } from '@/types';
import SbSection from '@/components/sb-sections/SbSection.vue';

const comps = {
  Section: SbSection,
};

interface Props {
  blok: TemplatePageStoryblok;
}
defineProps<Props>();
</script>

<style scoped></style>
